import React from 'react';
import { View, Pressable } from 'react-native';
import { MaterialIcons } from '@expo/vector-icons';
import SerialScanModal from './SerialScanModal';

type Props = {
    manufacturer_name: string;
    onDetected: (serial: string) => void;
    onAddedSuccess?: (info: { manufacturer: string; serial: string; chargerId?: string; associationId?: string }) => void;
    onClosed?: () => void;
    iconSize?: number;
    iconColor?: string;
    singleMode?: boolean;
};

const SerialCameraAddon: React.FC<Props> = ({ manufacturer_name, onDetected, onAddedSuccess, onClosed, iconSize = 24, iconColor = '#636363', singleMode = false }) => {
    const [visible, setVisible] = React.useState(false);
    
    return (
        <View>
            <Pressable
                onPress={() => { setVisible(true); }}
                style={({ pressed }) => ({ opacity: pressed ? 0.7 : 1 })}
            >
                <MaterialIcons name="camera-alt" size={iconSize} color={iconColor} />
            </Pressable>
            <SerialScanModal
                visible={visible}
                onClose={() => { setVisible(false); onClosed && onClosed(); }}
                onSerialDetected={onDetected}
                manufacturer_name={manufacturer_name}
                onAddedSuccess={(info) => { onAddedSuccess && onAddedSuccess(info); }}
                singleMode={singleMode}
            />
        </View>
    );
};

export default SerialCameraAddon;

